class TimeboxComponent extends window.BAO.CustomElement() {
  static get styles() {
    return `
      :host {
        display: none;
      }
      :host([aria-hidden='true']) {
        display: block;
      }
    `;
  }

  static get requiredAttributes() {
    return ["aria-hidden", "data-expiry-date"];
  }

  connectedCallback() {
    super.connectedCallback();

    const currentDate = new Date().getTime();
    const expiryDate = new Date(this.dataset.expiryDate).getTime();

    this.setAttribute("aria-hidden", currentDate >= expiryDate);
  }
}

if (!window.customElements.get("timebox-component")) {
  window.customElements.define("timebox-component", TimeboxComponent);
}
